import React from 'react'


import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import SearchedTable from "../../../components/SearchedTable"
import { Button, TextField } from '@material-ui/core'
import Typography from '@material-ui/core/Typography';


function NotificationMemoList(props) {
  let newMemo = {}
  newMemo.companyId = props.companyId
  return (
    <Grid component={Paper} container spacing={3}>
       <Grid item xs={12}>
        <FormControl fullWidth>
        <Button variant="outlined" color="primary"
            onClick={props.editAction}>Создать новую заметку</Button>
            </FormControl>
        </Grid>
      <FormControl fullWidth>
        <SearchedTable 
        tableTitle="Заметки"
        tableDescription={{
          columns: props.tableColumns,
          data: props.tableData
        }}
        clickAction={(rowData, rowMeta) => {
            let id = rowData[0]
            //this.props.setCurrentCompany(id)
          }}
        />
      </FormControl>
    </Grid>
  )
}

export default NotificationMemoList